import axios from 'axios';

export const apiAxios = axios.create({
	baseURL: `${process.env.VUE_APP_BASE_API_URL}${process.env.VUE_APP_API_VERSION}`,
	timeout: process.env.NODE_ENV !== 'development' ? 20000 : 0,
	headers: {
		Authorization: `Token ${process.env.VUE_APP_API_TOKEN}`,
	}
});
